import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, reset } from 'redux-form';
import moment from 'moment';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import Form from 'react-bootstrap/lib/Form';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import Modal from 'react-bootstrap/lib/Modal';

import DateRange from '../DateRange';
import Avatar from '../../Avatar';
import Loader from '../../Loader';
import TimeField from '../TimeField';

import validate from './validate';
import submit from './submit';
import messages from '../../../locale/jsonMessages';
import { formatTime, generateTimes } from '../../../helpers/formatting';
import { contactHostClose } from '../../../actions/message/contactHostModal';
import billDetailsHelpers from '../../../helpers/billDetailsHelper';
import { contactHost } from '../../../actions/message/contactHost';

import streeing from '/public/siteImages/steering.svg';
import arrow from '/public/SiteIcons/rentNowArrow.svg';

import AskAIButton from '../../Common/AskAIButton/AskAIButton';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import ReservationMessage from '../../AIFeatures/OpenAI/Renter/ReservationMessage';
import { AIIcon, GoBackArrow } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import cs from '../../../components/commonStyle.css';
import c from '../../../components/ViewListing/common.css';

import { isRenterAIFeatureStatus } from '../../../helpers/aiFeatureStatusHelper';
import { dateFormat } from '../../../config';

import s from './ContactHost.css';
import { withQuery } from '../../../hoc/withGraphql';
import { userListing } from '../../../lib/graphql';


class ContactHost extends React.Component {
  static propTypes = {
    showContactHostModal: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    picture: PropTypes.string,
    profileId: PropTypes.number.isRequired,
    personCapacity: PropTypes.number.isRequired,
    minDay: PropTypes.number,
    maxDay: PropTypes.number,
    maxDaysNotice: PropTypes.string,
    blockedDates: PropTypes.array,
    availability: PropTypes.bool,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    contactHostClose: PropTypes.any.isRequired,
    formatMessage: PropTypes.any,
    maximumStay: PropTypes.bool,
  };

  static defaultProps = {
    showContactHostModal: false,
    id: 0,
    profileId: 0,
    displayName: null,
    picture: null,
    personCapacity: 0,
    minDay: 0,
    maxDay: 0,
    blockedDates: [],
    availability: false,
    startDate: null,
    endDate: null,
    maximumStay: false,
    minimumStay: false
  };

  constructor(props) {
    super(props);
    this.state = {
      isContactHostModal: true
    }
  }

  renderGuests = (personCapacity) => {
    let rows = [];
    for (let i = 1; i <= personCapacity; i++) {
      rows.push(<option key={i} value={i}>{i} {i > 1 ? 'guests' : 'guest'}</option>);
    }
    return rows;
  }

  renderFormControlSelect = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl componentClass="select" {...input} className={className} >
          {children}
        </FormControl>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    )
  }

  renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className, placeholder }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <label className='commonLabelText'>{label}<sub className='isRequiredStar'>*</sub></label>
        <FormControl
          {...input}
          className={className}
          componentClass="textarea"
          placeholder={placeholder}
          rows={'5'}
        >
          {children}
        </FormControl>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    )
  }


  handleCloseModal = () => {
    this.setState({ isContactHostModal: true })
  }

  handleOpenModal = () => {
    this.setState({ isContactHostModal: false })
  }

  handleGoBack = () => {
    this.setState({ isContactHostModal: true })
  }

  handleOpenAIModal = (isTimeChosen, isValue) => {
    const { startDate, endDate, startTime, endTime } = this.props;
    let isStartTimeChosen, isEndTimeChosen;
    isStartTimeChosen = isNaN(startTime) ? false : true;
    isEndTimeChosen = isNaN(endTime) ? false : true;
    if (isTimeChosen && !isValue) {
      showToaster({ messageId: 'ContactHostSameTimeErrorForAI', toasterType: 'error' });
      return
    }
    if (startDate && endDate && isStartTimeChosen && isEndTimeChosen) {
      this.handleOpenModal()
    } else {
      showToaster({ messageId: 'aiErrorContent', toasterType: 'error' })
    }
  }

  renderWarningBlock = (content, error) => {
    let bgClass;
    if (error) {
      bgClass = s.alertBlockError;
    } else {
      bgClass = s.alertBlockSuccess;
    }
    return (
      <div className={cx(s.alertBlock, bgClass, cs.spaceBottom3, s.mobileMargin)}>
        <h4 className={cx(cs.commonContentText)}>
          {content}
        </h4>
      </div>
    );
  }

  closeContactHostModal = () => {
    if (this.state.isContactHostModal) {
      this.props.contactHostClose()
    } else {
      this.setState({ isContactHostModal: true })
    }
  }

  handleClick = (values, dispatch) => {
    const {
      userListingData,
      specialPricing,
      serviceFees,
      base,
      rates,
      contactHostClose,
      startDate,
      endDate,
      startTime,
      endTime,
      contactHost
    } = this.props;

    const UserListing = userListingData?.UserListing;
    const listingData = UserListing?.listingData;

    const {
      isAverage,
      isDayTotal,
      discount,
      serviceFee,
      total,
      isSpecialPriceAssigned,
      discountType,
      priceForDays,
      hostServiceFee,
      promoDiscount,
      dayDifference
    } = billDetailsHelpers({
      specialPricing,
      serviceFees,
      monthlyDiscount: listingData?.monthlyDiscount,
      weeklyDiscount: listingData?.weeklyDiscount,
      base,
      rates,
      currency: listingData?.currency,
      startDate,
      endDate,
      startTime,
      endTime,
      basePrice: listingData?.basePrice,
      delivery: 0,
      securityDeposit: listingData?.securityDeposit,
      promoValue: 0
    });

    contactHost(
      values.listId,
      values.host,
      values.content,
      startDate,
      endDate,
      values.personCapacity || 1,
      values.hostEmail,
      values.firstName,
      values.startTime,
      values.endTime,
      isAverage,
      isDayTotal,
      discount,
      serviceFee,
      total,
      isSpecialPriceAssigned,
      discountType,
      priceForDays,
      hostServiceFee,
      listingData?.securityDeposit,
      dayDifference,
      listingData?.currency,
      listingData?.basePrice,
    );

  };

  render() {
    const { formatMessage } = this.props.intl;
    const { showContactHostModal, message, travelReason, travelOptions } = this.props;
    const { id, minDay, maxDay, maxDaysNotice, blockedDates } = this.props;
    const { profileId, picture, displayName } = this.props;
    const { availability, startDate, endDate, isLoading, maximumStay, minimumStay } = this.props;
    const { handleSubmit, submitting, startTime, endTime, aiMessageContent } = this.props;
    const { renterContactMessage, isAiFeatureEnabled, renterServicePlanAIFeatureStatus, aiRenterAccess } = this.props;
    const { isContactHostModal } = this.state;


    let isDateChosen, isTimeChosen, isValue = true, isToday = false;
    let momentStartDate, momentEndDate, dayDifference, startTimeLookup, endTimeLookup;
    let disabled, loadingStatus;
    isDateChosen = startDate != null && endDate != null || false;
    isTimeChosen = isNaN(startTime) || isNaN(startTime) ? false : true;
    momentStartDate = moment(startDate);
    momentEndDate = moment(endDate);
    dayDifference = momentEndDate.diff(momentStartDate, 'days');

    startTimeLookup = generateTimes(0, 1410, isToday);
    endTimeLookup = generateTimes(0, 0);

    if (momentStartDate) {
      isToday = moment(moment(momentStartDate)).isSame(moment(), 'day');
      startTimeLookup = generateTimes(0, 1410, isToday);
    }

    if (momentEndDate) {
      isToday = moment(moment(momentEndDate)).isSame(moment(), 'day');
      endTimeLookup = generateTimes(0, 0, isToday);
    }

    if ((startTime >= endTime) && dayDifference == 0) {
      isValue = false;
    }
    if (startTime >= 0 && isNaN(endTime)) {
      isValue = false;
    }

    if (!isDateChosen || !availability || !isTimeChosen || !isValue) {
      disabled = true;
    } else {
      disabled = false;
    }
    loadingStatus = isLoading || false;


    let checkInDate, checkOutDate;
    checkInDate =
      startDate != null
        ? moment(moment(startDate).format("YYYY-MM-DD")).format(dateFormat?.shortDateFormat)
        : "";
    checkOutDate =
      endDate != null
        ? moment(moment(endDate).format("YYYY-MM-DD")).format(dateFormat?.shortDateFormat)
        : "";



    let formattedStartTime = formatTime(startTime);
    let formattedEndTime = formatTime(endTime);
    const formValues = {
      checkIn: `${checkInDate}, ${formattedStartTime}`,
      checkOut: `${checkOutDate}, ${formattedEndTime}`,
      hostName: displayName,
      aiMessage: message,
      aiMessageContent,
      travelReason
    }

    let title = isContactHostModal ? 'contactHost' : 'generateWithAI';
    let isContactOwnerAIFeatureEnabled = isRenterAIFeatureStatus({
      isRenterAIEnabled: renterContactMessage,
      isGlobalAIEnabled: isAiFeatureEnabled,
      hasActiveServicePlan: renterServicePlanAIFeatureStatus,
      servicePlanUsers: aiRenterAccess
    })

    return (
      <Modal show={showContactHostModal}
        onHide={() => this.closeContactHostModal()}
        // onHide={contactHostClose}
        animation={false}
        dialogClassName={cx('commonModalContainer',
          (isContactHostModal ? s.contactHostModalContainer : 'globalModalContainer'))}>
        <Modal.Header closeButton className='commonModalHeader'>
          <Modal.Title className={cx('commonModalTitle', cs.displayFlex, cs.gap16, cs.alignCenter, 'isolate')}>
            {!isContactHostModal && <GoBackArrow onClick={() => this.handleGoBack()} className={cx(s.contactHostGoBackArrow, 'rtlRotate')} />}
            <div>
              <FormattedMessage {...messages[title]} />&nbsp;
              {!isContactHostModal &&
                <span className={cx(cs.aiBadgeStyle, cs.top3)}>
                  <AIIcon />
                  <span className={cs.aiTextColor}>AI</span>
                </span>
              }
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass='commonModalBody'>
          {
            isContactHostModal ? <div className={s.displayGrid}>
              <div className={cx(s.avatarSection, 'contactHostAvatarRTL')}>
                <div className={cx(cs.textAlignCenter, s.paddingCommon)}>
                  <Avatar
                    source={picture}
                    height={96}
                    width={96}
                    title={displayName}
                    className={cx(s.profileAvatar, c.profileAvatarLink)}
                    withLink
                    linkClassName={cs.displayinlineBlock}
                    profileId={profileId}
                  />
                  <div className={cs.spaceTop1}>
                    <a href={"/users/show/" + profileId} target="_blank" className={cx(cs.commonSubTitleText, cs.siteLinkColor, cs.fontWeightBold, cs.paddingTop3)}>
                      {displayName}
                    </a>
                  </div>
                </div>
                <hr className={cx(cs.listingHorizoltalLine, s.contactLine)} />
                <div className={s.paddingCommon}>
                  <p className={cx(cs.commonContentText, cs.fontWeightMedium)}><FormattedMessage {...messages.contactHostInfo1} />:</p>
                  <h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingTop3, s.displayFlex)}>
                    <img src={streeing} className={cx(s.streeingImage, 'commonIconSpace')} />
                    <span>
                      <FormattedMessage {...messages.contactHostInfo2} /> {displayName} <FormattedMessage {...messages.contactHostInfo3} />
                    </span>
                  </h6>
                  <h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingTop3, s.displayFlex)}>
                    <img src={streeing} className={cx(s.streeingImage, 'commonIconSpace')} />
                    <span>
                      <FormattedMessage {...messages.contactHost7} />
                    </span>
                  </h6>
                  <h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingTop3, s.displayFlex)}>
                    <img src={streeing} className={cx(s.streeingImage, 'commonIconSpace')} />
                    <span><FormattedMessage {...messages.contactHostInfo6} />!</span>
                  </h5>
                </div>
              </div>

              <div className={cx(s.dateSection, 'contactHostDateSectionRTL')}>
                <Loader
                  show={loadingStatus}
                  type={"page"}
                >
                  <div>
                    {
                      (!isDateChosen || !isTimeChosen && (!maximumStay && !minimumStay && availability)) && this.renderWarningBlock(<h4 className={cs.commonContentText}><FormattedMessage {...messages.hostErrorMessage1} /></h4>)
                    }
                    {
                      !maximumStay && !availability && !minimumStay && isDateChosen && this.renderWarningBlock(<p className={cs.commonContentText}><FormattedMessage {...messages.hostErrorMessage2} /></p>, "error")
                    }
                    {
                      isDateChosen && maximumStay && this.renderWarningBlock(<h6 className={cs.commonContentText}><FormattedMessage {...messages.maximumStay} /> {maxDay} <FormattedMessage {...messages.nights} /></h6>, "error")
                    }
                    {
                      isDateChosen && minimumStay && this.renderWarningBlock(<h6 className={cs.commonContentText}><FormattedMessage {...messages.minimumStayText} /> {minDay} <FormattedMessage {...messages.nights} /></h6>, "error")
                    }
                    {
                      availability && isDateChosen && isValue && isTimeChosen && this.renderWarningBlock(<p className={cs.commonContentText}><FormattedMessage {...messages.hostErrorMessage3} /></p>)
                    }
                    {
                      isTimeChosen && !isValue &&
                      this.renderWarningBlock(<div className={s.errorCss}><FormattedMessage {...messages.chooseDifferentEndTime} /></div>)
                    }
                    <Form onSubmit={handleSubmit(this.handleClick)}>
                      <div className="oneColumnGrid">
                        <div >
                          <label className='commonLabelText'><FormattedMessage {...messages.dates} /><sub className='isRequiredStar'>*</sub></label>
                          <div className={'viewListingDate contactHostCalendar'}>
                            <DateRange
                              listId={id}
                              minimumNights={minDay}
                              maximumNights={maxDay}
                              blockedDates={blockedDates}
                              formName={"ContactHostForm"}
                              maxDaysNotice={maxDaysNotice}
                            />
                          </div>
                        </div>
                        <div>
                          <label className='commonLabelText'>{formatMessage(messages.startLabel)}<sub className='isRequiredStar'>*</sub></label>
                          <div className={s.displayTimeGrid}>
                            <TimeField
                              name={"startTime"}
                              className='commonSelectField'
                              TimeLookup={startTimeLookup}
                              formName={"ContactHostForm"}
                              label={formatMessage(messages.tripStart)}
                              listId={id}
                              startDate={startDate}
                              endDate={endDate}
                              startTime={startTime}
                              endTime={endTime}
                              maximumNights={maxDay}
                              value={startTime}
                              minimumNights={minDay}
                            />
                            <TimeField
                              name={"endTime"}
                              className='commonSelectField'
                              TimeLookup={endTimeLookup}
                              formName={"ContactHostForm"}
                              label={formatMessage(messages.tripEnd)}
                              listId={id}
                              startDate={startDate}
                              endDate={endDate}
                              startTime={startTime}
                              endTime={endTime}
                              maximumNights={maxDay}
                              value={endTime}
                              minimumNights={minDay}
                            />
                          </div>
                        </div>

                        <Field
                          name="content"
                          component={this.renderFormControlTextArea}
                          className='commonTextAreaField'
                          label={formatMessage(messages.contactMessage)}
                          placeholder={formatMessage(messages.textBoxMessage)}
                        />

                        <AskAIButton
                          onClick={() => this.handleOpenAIModal(isTimeChosen, isValue)}
                          btnText={formatMessage(messages.generateWithAILabel)}
                          isButtonVisible={isContactOwnerAIFeatureEnabled}
                        />
                      </div>
                      <Button className={cx(cs.btnPrimary, cs.fullWidth, cs.spaceTop4)} type="submit" disabled={submitting || disabled}>
                        <FormattedMessage {...messages.sendMessage} />
                        <img src={arrow} className={cx(s.arrowIconCss, 'sliderArrowRTL')} />
                      </Button>
                    </Form>
                  </div>
                </Loader>
              </div>
            </div> :
              <ReservationMessage
                initialValues={formValues}
                formValues={formValues}
                handleCloseModal={() => this.handleCloseModal()}
                isContactHost
              />
          }

        </Modal.Body>
        {!isContactHostModal &&
          <Modal.Footer className='commonAiModalFooter'>
            <span className={cs.aiFooterInfoText}><span className={cs.fontWeightExtraBold}>{formatMessage(messages.aiDeclaimerLabelOne)}</span>&nbsp;{formatMessage(messages.aiDeclaimerLabelTwo)}</span>
          </Modal.Footer>
        }
      </Modal>
    );
  }
}

ContactHost = reduxForm({
  form: "ContactHostForm",
  validate
})(ContactHost);

const selector = formValueSelector('ContactHostForm');
const reservationMessageSelector = formValueSelector('ReservationMessage');


const mapState = (state) => ({
  isLoading: state?.viewListing?.isLoading,
  showContactHostModal: state?.viewListing?.showContactHostModal,
  availability: state?.viewListing?.availability,
  maximumStay: state?.viewListing?.maximumStay,
  minimumStay: state?.viewListing?.minimumStay,
  startDate: selector(state, 'startDate'),
  endDate: selector(state, 'endDate'),
  startTime: Number(selector(state, 'startTime')),
  endTime: Number(selector(state, 'endTime')),
  message: selector(state, 'content'),
  aiMessageContent: reservationMessageSelector(state, 'aiMessageContent'),
  travelReason: reservationMessageSelector(state, 'travelReason'),
  travelOptions: formValueSelector(state, 'travelReason'),
  isAiFeatureEnabled: state.siteSettings.data?.aiTextGeneration,
  renterContactMessage: state?.siteSettings?.data?.renterContactMessage,
  renterServicePlanAIFeatureStatus: state?.account?.data?.renterServicePlanAIFeatureStatus,
  aiRenterAccess: state?.siteSettings?.data?.aiRenterAccess,
  specialPricing: state?.viewListing?.specialPricing,
  serviceFees: state?.book?.serviceFees,
  base: state?.currency?.base,
  rates: state?.currency?.rates,
});

const mapDispatch = {
  contactHostClose,
  contactHost
};
export default injectIntl(
  withStyles(cs, c, s)(
    withQuery(userListing, {
      name: 'userListingData',
      options: props => ({
        variables: {
          listId: props.id,
        },
        ssr: false,
        fetchPolicy: 'network-only',
      })
    })(
      connect(mapState, mapDispatch)(ContactHost)
    )
  )
);
